import axiosIns from '@/libs/axios'

const ROOT_URL = '/Admin/core/cropper_upload'
export default {
  namespaced: true,
  state: {
    uploadImage: null,
    dataSave: {
      message: null,
      status: null,
      id: null,
    },
    uploading: false,
  },
  getters: {
    dataSaveStatus(state) {
      return state.dataSave
    },
    uploading(state) {
      return state.uploading
    },
  },
  mutations: {
    SET_DATA_SAVE(state, data) {
      state.dataSave = data
    },
    SET_UPLOAD_IMAGE(state, data) {
      state.uploadImage = data
    },
    SET_UPLOADING(state, data) {
      state.uploading = data
    },
  },
  actions: {
    uploadImage({ commit }, postData) {
      commit('SET_UPLOADING', true)
      const formData = new FormData()
      formData.append('folder', postData.folder)
      formData.append('upload_image', postData.upload_image, postData.filename)
      formData.append('resize', 1200)
      return axiosIns
        .post(ROOT_URL, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then(response => {
          commit('SET_UPLOAD_IMAGE', response.data.image)
          commit('SET_UPLOADING', false)
          return response.data
        })
        .catch(error => console.error(error))
    },
  },
}
